<template>
  <div id="menu-manager-app"
    :class="[{'logged-in':isAuthenticated}]"
    v-shortkey="['shift','esc']"
    @shortkey="loginOrToggleUI()"
  >
    <!-- <div :style="`display:block;position:fixed;top:0;right:0;background-color:${puppeteerReady? 'green': 'red'};color:white;padding:20px;`">{{ puppeteerReady? 'Ready to Print': 'Working...' }}</div> -->
    <locations-list v-if="locations.length"/>
    <notifications position="bottom right"/>  
    <login-modal/>
    <input type="hidden" id="pptr-ready" :value="puppeteerReady">
  </div>
</template>

<script>
import axios from 'axios'

import MenusList from './components/MenusList';
import LocationsList from './components/Location/LocationsList';
import LoginModal from './components/UI/LoginModal';

import { mapState, mapGetters } from 'vuex'

global.WPAPI = require('wpapi');

export default {
  name: 'menu-manager-app',
  components : {
    'menus-list':MenusList,
    'locations-list': LocationsList,
    'login-modal': LoginModal,
  },
  data () {
    return {
    }
  },
  created() {
    let api = WPAPI({
      endpoint: this.wpData.rest_url,
      nonce : this.wpData.nonce
    });
    api.locations = api.registerRoute( 'wp/v2', `/${this.wpData.cpts.locations}/(?P<id>)` );
    api.menuBlocks = api.registerRoute( 'wp/v2', `/${this.wpData.cpts.menuBlocks}/(?P<id>)` );
    api.menus = api.registerRoute( 'wp/v2', `/${this.wpData.cpts.menus}/(?P<id>)` );
    this.$store.commit('SET_WPAPI', api);
  }, // created()

  async mounted() {
    let has_single_location = parseInt( this.wpData.location ) > 0;
    let is_location_array = typeof this.wpData.location == "object" && this.wpData.location.length > 0 ;
    if( has_single_location || is_location_array ) {

      // Short circuit if locations data
      // is already on the page (e.g. localized WP asset)
      if( this.wpData.locations.length ) {
        this.$store.commit('setLocations', this.wpData.locations)
        return;
      }
      let locations = await this.getLocations();
      this.$store.commit('setLocations', locations)

    } else if( this.wpData.menu_board_id > 0 ) {

      document.body.classList.add(`single-${this.wpData.cpts.menus}`);

      let menuBoard;
      if( typeof this.wpData.menuObj == 'object' ) {
        menuBoard = this.wpData.menuObj;
      } else  {
        menuBoard = await this.getMenuObj();
      }
      this.$store.commit('setMenuBoard', menuBoard)
      // use the parent location from the menu board
      // to set the global location. the wpData.menu_ids key should
      // restrict what shows up anyway, but we'll have access to the
      // location data for DrinksMenuFooter and loc meta, etc.
      if( menuBoard.acf.parent_location.length > 0 ) {
        let parentLocation;
        if( typeof this.wpData.parent_location == 'object' ) {
          parentLocation = [ this.wpData.parent_location ];
        } else  {
          parentLocation = await this.getLocations(menuBoard.acf.parent_location[0]);
        }

        this.$store.commit('setLocations', parentLocation)
      }

    }
  }, // mounted

  methods : {
    loginOrToggleUI() {

      if( !this.isAuthenticated && this.wpData.wp_login_url ) {
        window.location = this.wpData.wp_login_url;
        return false;
        // this.$modal.show('login-modal');
      } else if ( this.authToken ) {
        this.$notify(`${this.hideGlobalUI? 'Displaying': 'Hiding'} extra controls`)
        this.$store.commit('toggleUI')
      }
    }, // loginOrToggleUI

    async getLocations(loc_id) {
      if( "undefined" == typeof loc_id ) {
        loc_id = this.wpData.location;
      }
      console.log('[ app get locations ]')
      const response = await axios( `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.locations}?include=${loc_id}` )
      return response.data;
    }, // getLocations

    async getMenuObj() {
      console.log('[ app get menu obj ]')
      const response = await axios( `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.menus}?include=${this.wpData.menu_board_id}` )
      return response.data[0];
    }, // getMenuObj

  },
  computed : {
    ...mapState(['hideGlobalUI','authToken','wpData', 'locations', 'menuBoard','puppeteerReady']),
    ...mapGetters(['isAuthenticated'])
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Jaldi:400,700|Nunito+Sans:400,700');

html {
  font-size:15px;
  @media (min-width:1441px) {
    font-size:16px;
  }
}


#menu-manager-app, p {
  line-height:normal;
  font-size:15px;
}
#menu-manager-app {
  display: flex;
  justify-content: center;
  align-items: center;
  
  button {
    border-radius:0 !important;
  }
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
  &.md-12 { font-size: 12px; }
  &.md-16 { font-size: 16px; }
  &.md-18 { font-size: 18px; }
  &.md-24 { font-size: 24px; }
  &.md-36 { font-size: 36px; }
  &.md-48 { font-size: 48px; }  

  &.left {
    margin-right:3px;
  }
  &.right {
    margin-left:3px;
  }
}  

#menu-manager-app {
  // font-family: 'Avenir', sans-serif;
  font-family: 'Nunito Sans', sans-serif;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-slow-enter-active, .fade-slow-leave-active {
  transition: opacity 1.5s ease-out;
}

.fade-slow-enter, .fade-slow-leave-to {
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/App.vue